export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20composition%20of%20modern%20fashion%20lifestyle%20elements%20floating%20in%20organized%20grid%20pattern%2C%20sneakers%20hoodies%20bags%20and%20accessories%20arranged%20with%20generous%20negative%20space%2C%20warm%20golden%20hour%20glow%20from%20upper%20left%2C%20soft%20cream%20and%20sand%20background%20with%20subtle%20texture%2C%20clean%20contemporary%20editorial%20aesthetic%2C%20ethereal%20and%20aspirational%20mood%20with%20gentle%20atmospheric%20haze&width=1920&height=1080&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet lifestyle product photography"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-20 pb-10">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/80 backdrop-blur-sm rounded-full mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">Updated for 2026</span>
            <span className="text-xs text-foreground-400">·</span>
            <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">Beginner Friendly</span>
            <span className="text-xs text-foreground-400">·</span>
            <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">Free Resource</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight text-balance mb-6">
            Hipobuy Spreadsheet
            <br />
            <span className="text-accent-300">The Ultimate Product Discovery</span>
            <br />
            <span className="text-background-50/80">&amp; Shopping Guide</span>
          </h1>

          <p className="text-base md:text-lg text-background-50/75 max-w-2xl mx-auto mb-10 text-balance leading-relaxed">
            Find the latest Hipobuy Spreadsheet resources, curated product collections, buying guides and expert comparisons. 
            Explore organized spreadsheets that help shoppers discover products faster and make smarter purchasing decisions.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              hipobuy sheet
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-foreground-950 bg-background-50 hover:bg-background-100 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-shopping-bag-line text-lg"></i>
            </a>
            <a
              href="/hipobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-medium text-background-50/90 border border-background-50/30 hover:border-background-50/60 hover:text-background-50 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Start Beginner Guide
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-background-50/30 rounded-full flex items-start justify-center p-1">
          <div className="w-1 h-2.5 bg-background-50/50 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}